import styled from 'styled-components'
import { Block } from '../block/block'

export const Tabs = styled(Block)`
  @media (max-width: 639px) {
    overflow: hidden;
    overflow-x: auto;
    min-height: 50px;
    -webkit-overflow-scrolling: touch;
  }
`
